import React, { JSX } from 'react';
import { createFilter } from 'react-select';
import { ApiBaseData } from '@ibe/api';
import { FormConfig, SelectElement } from '../types/types';
import FormSelect from './FormSelect';
import { FilterOptionOption } from '../../Components/Form/Select/Select';

interface Props {
  config: SelectElement;
  keySuffix?: FormConfig['keySuffix'];
  externalData?: Record<string, unknown>;
}

const SelectWrapper = (props: Props): JSX.Element => {
  const {
    config: {
      key,
      externalDataOptions,
      label,
      options: selectOptions,
      placeholder,
      boldLabel,
      showErrorIcon,
      noMenuPortal,
      isSearchable = true,
      disabled,
      validateOnBlurOnly,
      showSuccessState
    },
    keySuffix,
    externalData
  } = props;

  const options =
    selectOptions ||
    ((externalDataOptions && externalData && externalData[externalDataOptions]
      ? externalData[externalDataOptions]
      : []) as ApiBaseData[]);

  return (
    <FormSelect
      name={`${key}${keySuffix || ''}`}
      options={options}
      getLabel={(option: ApiBaseData): string => (option ? option.description : '')}
      getValue={(option: ApiBaseData): string => (option ? option.code : '')}
      selectedOption={(value): ApiBaseData | undefined =>
        options.find(option => option.code === value)
      }
      getCurrentValue={(option): string => option.code}
      label={label}
      boldLabel={boldLabel}
      placeholder={placeholder}
      showErrors
      isSearchable={isSearchable}
      filterOption={createFilter({
        matchFrom: 'any',
        stringify: (option: FilterOptionOption<ApiBaseData>) => option.data.description
      })}
      showErrorIcon={showErrorIcon}
      noMenuPortal={noMenuPortal}
      disabled={disabled}
      validateOnBlurOnly={validateOnBlurOnly}
      showSuccessState={showSuccessState}
    />
  );
};

export default SelectWrapper;
